// extracted by mini-css-extract-plugin
export default {"root":"sRSvQy0_Dl","question":"B75hsodWDW","answer":"kAffpKRxNQ","question_isExpandable":"Xj3GgyqeBX","icon":"cgOwJQ9_ug","title":"uN0dnLwWdU"};